import { LoadingSpinner } from '@paypalcorp/pp-react';
import React from 'react';
import styles from './LoadingOverlay.module.less';

const LoadingOverlay = () => {
  return (
    <div className={styles.loading_overlay}>
      <LoadingSpinner screenReaderText="loading" size="lg" />
    </div>
  );
};

export default LoadingOverlay;
